import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import axios from 'axios';
import config from '../config';

function CallReportForm() {
  const { customAgentId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    callDate: '',
    duration: '',
    status: 'completed',
    notes: ''
  });
  const [error, setError] = useState('');
  const [agent, setAgent] = useState(null);

  useEffect(() => {
    const fetchAgent = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/api/agents/custom/${customAgentId}`);
        setAgent(response.data);
      } catch (err) {
        setError('Failed to fetch agent details');
      }
    };

    fetchAgent();
  }, [customAgentId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${config.apiBaseUrl}/api/call-reports`, {
        ...formData,
        agentId: agent._id
      });
      navigate(`/agents/${customAgentId}/call-reports`);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create call report');
    }
  };

  if (!agent) {
    return (
      <Container maxWidth="sm">
        <Alert severity="error">Loading agent details...</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h5" component="h1" gutterBottom>
            New Call Report for {agent.name}
          </Typography>
          
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              fullWidth
              margin="normal"
              type="datetime-local"
              label="Call Date"
              name="callDate"
              value={formData.callDate}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required
            />

            <TextField
              fullWidth
              margin="normal"
              type="number"
              label="Duration (minutes)"
              name="duration"
              value={formData.duration}
              onChange={handleChange}
              required
            />

            <FormControl fullWidth margin="normal">
              <InputLabel>Status</InputLabel>
              <Select
                name="status"
                value={formData.status}
                onChange={handleChange}
                label="Status"
                required
              >
                <MenuItem value="completed">Completed</MenuItem>
                <MenuItem value="missed">Missed</MenuItem>
                <MenuItem value="scheduled">Scheduled</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              margin="normal"
              multiline
              rows={4}
              label="Notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
            />

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between' }}>
              <Button
                variant="outlined"
                onClick={() => navigate(`/agents/${customAgentId}/call-reports`)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
              >
                Create Report
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default CallReportForm; 